import { createSelector } from '@reduxjs/toolkit';

import { NotificationType } from '@paragon/notification-tools';

import { RootState } from '..';

const SEVERITIES: NotificationType[] = ['success', 'info', 'warning', 'error'];

function getSeverity(type: NotificationType): number {
  return SEVERITIES.indexOf(type);
}

const getAllDelayedNotifications = (state: RootState) => state.delayedNotifications;

export const createHasDelayedNotifications = createSelector(getAllDelayedNotifications, (notifications) => {
  const resultCache = new Map<string, NotificationType>();
  return (componentDesignGuid: string): NotificationType | null => {
    if (resultCache.has(componentDesignGuid)) return resultCache.get(componentDesignGuid)!;

    const relevantNotifications = notifications[componentDesignGuid];
    if (relevantNotifications == null || relevantNotifications.length === 0) return null;

    let result: NotificationType = 'success';
    for (const notification of relevantNotifications) {
      if (getSeverity(notification.options.variant) > getSeverity(result)) {
        result = notification.options.variant;
      }
    }

    return result;
  };
});
